import { Component, OnInit, Inject } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtListeCursusComponent } from '../avt-liste-cursus/avt-liste-cursus.component';
@Component({
  selector: 'app-avt-cursus',
  templateUrl: './avt-cursus.component.html',
  styleUrls: ['./avt-cursus.component.scss']
})
export class AvtCursusComponent implements OnInit {
  constructor(public generalService:GeneralService, public route: ActivatedRoute,public router:Router) { }
  exist : boolean = true;
  disableBtnAjouter : boolean = false;
  cursus;
  dsCursus;
  //code cursus
  param_code : string;
  // mode : 1 ajout , 2 modifier , 3consulter
  typeTrs  : string;
  //cursus avans modification
  cursusInitial;
  index:  number = 0;
  disabled : boolean = false;
  ngOnInit() 
  {
    this.cursus = {}
    this.readParamUrl();
  }
 
  enregistrerCursus(form)
  {
    if(form.form.valid)
    {
      if(this.dsCursus != undefined)
        {
          this.enregistrer();
        }
        else
          this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
    }
  }
  saveCursus()
  {
    this.generalService.rechercheTable("recherche/tbdata?tablere=ApplyCursus").subscribe(data =>
    {
      var lastCode =  data.map(cursus => cursus.Cursus_Code).reduce(function(a,b) {return Math.max(a, b);})
      var existeCursus : boolean = false;
      if(this.typeTrs == "1")
        existeCursus = data.find(cursus => { return cursus.Cursus_Titre.replace(/\s/g, '') == this.cursus.Cursus_Titre.replace(/\s/g, '')}) != undefined
      else
        existeCursus = data.find(cursus => { return cursus.Cursus_Titre.replace(/\s/g, '') == this.cursus.Cursus_Titre.replace(/\s/g, '') && cursus.Cursus_Code != this.cursus.Cursus_Code}) != undefined
      if(!existeCursus)
      {
        this.generalService.enregisterTable(this.dsCursus).subscribe(data =>
        {
          this.generalService.dialogSuccess("Enregistré",true);
          this.disableBtnAjouter = false;
          this.dsCursus = undefined;
          if(this.typeTrs == "1")
          {
            this.param_code = lastCode;
            this.index = 1;
            this.typeTrs = "2";
            this.getCursus();
            return;        
          }
          this.getCursus();
        },
        error =>
        {
          this.exist = true;
          this.disableBtnAjouter = false;
          this.generalService.dialogSuccess("Non enregistré",false);
        })
      }
      else
      {
        this.exist = true;
        this.disableBtnAjouter = false;
        this.generalService.dialogSuccess("Ce nom du cursus existe déjà",false)
      }
    })
  }
  enregistrer()
  {
    if(this.dsCursus != undefined)
    {
      this.exist = false;
      this.disableBtnAjouter = true;
      this.param_code = this.cursus.Cursus_Code
      if(this.typeTrs == "2")
      {
        if(this.cursusInitial.Cursus_Duree == this.cursus.Cursus_Duree)
          this.saveCursus();
        else
        {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = 
          {
            message:"Vous avez changé la durée du cursus! Voulez-vous continuer",
            btnOk : {class:"colorRed",icon:"keyboard_return",text:"Modifier"},
            btnAnnuler : {class:"colorRed",icon:"close",text:"Annuler"}
          }
          var dialogRef = this.generalService.dialog.open(AvtDialogDeleteComponent,dialogConfig);
          dialogRef.afterClosed().subscribe(result =>
          {
            if(result == "supprimer")
            { 
              this.saveCursus();
            }
            else
            {
              this.disableBtnAjouter = false;
              this.exist = true;
            }
          })
        }
      }
      else
      this.saveCursus();
    }
    else
      this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
  }
  //get cursus from server 
  getCursus()
  {
    var url = this.generalService.urlApplyCursus;
    if(this.typeTrs == "2" || this.typeTrs == "3")
      url += "&val="+this.param_code;
    this.generalService.rechercheTable(url).subscribe(cursus =>
    {
      this.dsCursus = cursus;
      this.cursus = cursus.ApplyCursus[0];
      this.exist = true;
      if(this.typeTrs == "2")
      this.cursusInitial = JSON.parse(JSON.stringify(cursus.ApplyCursus[0]));
    })
  }
  init()
  {
    this.getCursus();
  }
  // redirec To Liste Cursus
  goToListeCursus()
  {
    this.generalService.popupCenter("/w/avt/liste/cursus")
    // this.router.navigate(['avt/liste/cursus']);
    // this.generalService.dialogOpend = this.generalService.dialog.open(AvtListeCursusComponent, new MatDialogConfig());
    // this.generalService.dialogOpend.afterClosed().subscribe(() =>
    // {
      
    // });
  }
  animationDone()
  {

  }
  tabChanged()
  {
    
  }
  //lecture des parametre passer dan url
  readParamUrl()
  {    
    this.route.params.subscribe(params => 
    {      
      this.exist = false;
      this.typeTrs = params['typeTrs'];
      if(this.typeTrs == "3")
        this.disabled = true
      else
        this.disabled = false
      this.param_code = params['param_code'];
      this.init();
    })
  }
}
